"use strict";

const config = require("config");

// 3rd party
import angular from "angular";
import nganimate from "angular-animate";
import ngsanitize from "angular-sanitize";
import ngcookies from "angular-cookies";

import uibootstrap from "angular-ui-bootstrap";
import uiselect from "ui-select";
import uirouter from "angular-ui-router";
import ngInfiniteScroll from "ng-infinite-scroll";

// alk dependencies
import alkfleetportal from "@trimblemaps/webtools-common/javascript/AngularJS/alk-fleetlink";

import alkfleetview from "./alk-fleetview";

(function () {
  var app = angular.module("fleetviewApp", [
    nganimate,
    ngsanitize,
    ngcookies,

    uirouter,
    uibootstrap,
    uiselect,
    "ui.utils",
    "uiSwitch",
    ngInfiniteScroll,

    "pascalprecht.translate",
    "tmh.dynamicLocale",

    alkfleetportal,
    alkfleetview,
    "alk.authentication",
    "alk.services",
    "alk.directives",
    "alk.constants",
    "alk.analytics",
    "alk.filters",
    "alk.maps",
    "alk.uirouter",
    "alk.uirouter",
    "alk.modal",
    "alk.cloud",
    "alk.forms",
    "alk.translations",
    "alk.marketing",
    "alk.companyAdmin",
    "alk.sso",
    "alk.email",
    "tm.navButtonsThreeStack",
    "visibilityChange",

  ]);

  app.constant("_", require("lodash")); // todo: don"t need to have constants for third party libraries, can use require("moment") in the files that need it.
  app.constant("ALKMaps", window.ALKMaps);
  app.constant("moment", require("moment")); // todo: don"t need to have constants for third party libraries, can use require("moment") in the files that need it.
  app.constant("turf", window.turf);
  app.constant("LRUCache", require("lru-cache")); // todo: don"t need to have constant for lru-cache.  Can put require("lru-cache") in the files that need it.
  app.constant("STATUSES", {
    submitted: {
      "value": 0,
      "class": "default",
      "text": "common.Submitted"
    },
    review: {
      "value": 1,
      "class": "info",
      "text": "common.InReview"
    },
    accepted: {
      "value": 2,
      "class": "success",
      "text": "common.Accepted"
    },
    rejected: {
      "value": 3,
      "class": "danger",
      "text": "common.Rejected"
    },
    deleted: {
      "value": 4,
      "class": "warning",
      "text": "common.Deleted"
    }
  });
  app.constant("appConstants", {
    SLIDE_ANIM_SPEED: 300,
  });
  app.constant("papaparse", require("papaparse"));
  app.constant("filesaver", require("file-saver"));

  // configure routes/states
  app.config(["$stateProvider", "$urlRouterProvider", "$urlMatcherFactoryProvider", "$locationProvider", function ($stateProvider, $urlRouterProvider, $urlMatcherFactoryProvider, $locationProvider) {
    $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise("/");
    $urlMatcherFactoryProvider.strictMode(false);

    $stateProvider
      .state("index", {
        abstract: true,
        views: {
          "@": {
            template: require("./layout/layout.html")
          }
        },
        resolve: {
          authenticated: ["$rootScope", "$q", function ($rootScope, $q) {
            var authenticatePromise = $q.defer();
            if ($rootScope.preloginFinished === true) {
              authenticatePromise.resolve();
              return authenticatePromise.promise;
            }

            $rootScope.$watch(() => $rootScope.preloginFinished, () => {
              if ($rootScope.preloginFinished === true) {
                authenticatePromise.resolve();
              }
            });

            return authenticatePromise.promise;
          }]
        }
      })
      .state("main", {
        parent: "index",
        url: "/app",
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        views: {
          "": {
            template: require("./layout/main.html")
          },
          "leftpanel": {
            template: "<div></div>"
          }
        },
        resolve: {
          messages: function (mapService) {
            "ngInject";
            return mapService.initializeMap();
          }
        }
      })
      .state("main.compliance", {
        url: "/compliance",
        params: {
          childState: "main.compliance.group",
          group: ""
        },
        reloadOnSearch: false,
        data: {
          requiresLogin: true
        },
        views: {
          "leftpanel@main": {
            component: "complianceGroups"
          }
        },
        onEnter: function (LayoutService) {
          LayoutService.openLeftHandPanel("500px");
        },
        onExit: function (LayoutService) {
          LayoutService.closeLeftHandPanel();
        }
      })
      .state("main.compliance.group", {
        url: "/:groupType?groupId",
        params: {
          parentState: "main.compliance",
          childState: "main.compliance.group.routes"
        },
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        views: {
          "leftpanel@main": {
            component: "complianceGroup"
          }
        }
      })
      .state("main.compliance.group.routes", {
        url: "/routes",
        params: {
          settings: {},
          parentState: "main.compliance.group",
          childState: "main.compliance.group.routes.route",
          pageNumber: 1
        },
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        views: {
          "sub@main.compliance.group": {
            component: "complianceGroupRoutes"
          }
        }
      })
      .state("main.compliance.group.routes.route", {
        url: "/routesdetails",
        params: {
          settings: {},
          parentState: "main.compliance.group.routes",
          pageNumber: 1,
          pageIndex: 0,
          totalPagesNum: 1
        },
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        views: {
          "leftpanel@main": {
            component: "complianceRouteDetails"
          }
        }
      })
      .state("main.compliance.querystring", {
        url: "/:queryUrl",
        params: {
          parentState: "main.compliance",
          childState: "main.compliance.querystring.routes",
          queryUrl: {}
        },
        reloadOnSearch: false,
        location: false,
        views: {
          "leftpanel@main": {
            component: "complianceQueryString"
          }
        }
      })
      .state("main.compliance.querystring.routes", {
        params: {
          settings: {},
          parentState: "main.compliance.group",
          currentState: "querystring",
          childState: "main.compliance.querystring.routes.details"
        },
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        views: {
          "query@main.compliance.querystring": {
            component: "complianceGroupRoutes"
          }
        }
      })
      .state("main.compliance.querystring.routes.details", {
        params: {
          settings: {},
          pageNumber: 1,
          pageIndex: 0,
          totalPagesNum: 1,
          parentState: "main.compliance.querystring",
          currentState: "querystring"
        },
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        views: {
          "leftpanel@main": {
            component: "complianceRouteDetails"
          }
        }
      })
      /* start of reports states */
      .state("reports", {
        parent: "index",
        url: "/app/reports",
        redirectTo: "reports.groups",
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        views: {
          "": {
            template: require("./reports/reports.main.html")
          },
          "leftpanel": {
            template: "<div></div>"
          },
          "reportspanel": {
            template: "<div></div>"
          }
        }
      })
      .state("reports.groups", {
        url: "/groups",
        reloadOnSearch: false,
        params: {
          childState: "reports.groups.group",
        },
        data: {
          requiresLogin: true
        },
        views: {
          "leftpanel@reports": {
            component: "complianceGroups"
          }
        },
        onEnter: function (LayoutService) {
          LayoutService.openLeftHandPanel("500px");
        },
        onExit: function (LayoutService) {
          LayoutService.closeLeftHandPanel();
        }
      })
      .state("reports.groups.group", {
        url: "/:groupType?groupId",
        params: {
          parentState: "reports.groups",
          childState: "reports.groups.group.data"
        },
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        views: {
          "leftpanel@reports": {
            component: "complianceGroup"
          }
        }
      })
      .state("reports.groups.group.data", {
        url: "/data",
        params: {
          settings: {}
        },
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        views: {
          "reportspanel@reports": {
            component: "reportsData"
          }
        }
      })
      /* end of reports states */
      .state("dashboard", {
        url: "/app/dashboard",
        data: {
          requiresLogin: true
        },
        views: {
          "": {
            component: "dashboard",
          }
        }
      })
      //Uses the common one in common js folder
      .state("companyadmin", {
        url: "/app/companyAdmin",
        data: {
          requiresLogin: true
        },
        controller: "companyAdminController",
        controllerAs: "vm",
        views: {
          "": {
            template: require("@trimblemaps/webtools-common/javascript/AngularJS/alk-company-admin/companyAdmin.html"),
          }
        }
      })
      .state("reset", {
        parent: "index",
        url: "/reset",
        data: {
          requiresLogin: false
        },
        views: {
          "": {
            component: "resetPassword"
          }
        }
      })
      .state("forgot", {
        parent: "index",
        url: "/forgot",
        data: {
          requiresLogin: false
        },
        views: {
          "": {
            component: "forgotPassword"
          }
        }
      })
      .state("user", {
        parent: "index",
        url: "/user",
        data: {
          requiresLogin: true
        },
        views: {
          "": {
            component: "user",
          }
        }
      })
      .state("login", {
        parent: "index",
        url: "/",
        data: {
          requiresLogin: false
        },
        views: {
          "": {
            template: require("./auth/login.html")
          }
        }
      })
      .state("acceptTerms", {
        parent: "index",
        url: "/acceptterms",
        data: {
          requiresLogin: true
        },
        views: {
          "": {
            component: "acceptTerms"
          }
        }
      })
      .state("terms", {
        parent: "index",
        url: "/terms",
        data: {
          requiresLogin: false
        },
        views: {
          "": {
            template: require("./auth/terms.html")
          }
        }
      })
      .state("tidRedirect", {
        parent: "index",
        url: "/tid/redirect",
        reloadOnSearch: false,
        data: {
          requiresLogin: false
        },
        views: {
          "": {
            template: require("./auth/login.html")
          }
        }
      });
  }]);

  app.config(["$uibTooltipProvider", function ($uibTooltipProvider) {
    $uibTooltipProvider.options({
      placement: "bottom",
      popupDelay: 0,
      animation: false
    });
  }]);

  // Angular Dynamic Locale
  app.config(["tmhDynamicLocaleProvider", function (tmhDynamicLocaleProvider) {
    tmhDynamicLocaleProvider.localeLocationPattern("node_modules/angular-i18n/angular-locale_{{locale}}.js");
  }]);

  // since config is not an angular component now, we know it at compile time, so the mouse-flow directive won"t even be included in builds not for production
  if (process.env.ENV === "production" || process.env.ENV === "qa") {
    app.config(["$compileProvider", function ($compileProvider) {
      $compileProvider.debugInfoEnabled(false);
    }]);
  }

  app.config(["alkAuthenticationServiceProvider", "alk.authentication.config", function (alkAuthenticationServiceProvider, authConfig) {
    // set up authentication provider
    alkAuthenticationServiceProvider.dataAnywhereUrl = config.daUrl;
    authConfig.applicationUrl = config.fleetViewUrl;
    authConfig.pcmwsUrl = config.pcmwsUrl;
    authConfig.alkmapsApiKey = config.alkmapsApiKey;
    authConfig.linkMappingUrl = config.linkMappingUrl;
    authConfig.ssoUrl = config.ssoUrl;
    authConfig.applicationName = config.applicationName;
    authConfig.clientId = config.tidClientId;
    authConfig.tidApplicationName = config.tidApplicationName;
    authConfig.trimbleCloudUrl = config.trimbleCloudUrl;

    //Check that trackJs variable is initialized without throwing an error if it isn't
    if (typeof trackJs !== "undefined" && config.trackJsEnvironment) {
      trackJs.configure({
        application: config.trackJsEnvironment
      });
    }
  }]);

  // configure the fleetportal services
  app.config(["alk.fleetportal.config", function (fleetPortalConfig) {
    fleetPortalConfig.apiUrl = config.fleetPortalUrl;
  }]);

  // configure the fleetview services
  app.config(["alk.fleetview.config", function (fleetViewConfig) {
    fleetViewConfig.apiUrl = config.fleetViewUrl;
  }]);

  app.config(["alk.routereporter.config", function (routeReporterConfig) {
    routeReporterConfig.apiUrl = config.routeReporterUrl;
  }]);

  app.config(["MessagesProvider", function (MessagesProvider) {
    MessagesProvider.setBroadcastType("ui.router");
  }]);

  // Execute bootstrapping code and any dependencies.
  /* Leave alkLocaleService here so it gets initialized on initial load of app*/
  app.run(["$rootScope", "$location", "$timeout", "$window", "UserProvider", "alkLocaleService", "$state", "$stateParams", "$templateCache", "$transitions", "appConstants", "stateService", "$q", "alkAuthenticationService", "savedMapInfo", "mapUtilities", "VisibilityChange",
    function ($rootScope, $location, $timeout, $window, UserProvider, alkLocaleService, $state, $stateParams, $templateCache, $transitions, appConstants, stateService, $q, alkAuthenticationService, savedMapInfo, mapUtilities, VisibilityChange) {
      $rootScope.$state = $state;
      $rootScope.$stateParams = $stateParams;
      $rootScope.language = "en-US"; // default language, this will be replaced when language is changed in "$translateChangeSuccess"

      // All NG-INCLUDE urls need to go here.  ng-include should be deprecated in favor of using controllers with html templates
      $templateCache.put("/app/auth/en-US/termsContent.html", require("./auth/en-US/termsContent.html"));
      $templateCache.put("/app/help/en-US/startPanelItems.html", require("./help/en-US/startPanelItems.html"));
      $templateCache.put("/app/help/startPanel.html", require("./help/startPanel.html"));

      // New angular-ui onBefore() will throw a console error if aborting transition with "return false", so need this line to silence error
      $rootScope.$state.defaultErrorHandler(function (error) {});

      $transitions.onBefore({}, function (trans) {

        let fromState = trans.$from();
        let toState = trans.$to();
        let fromParams = trans.params("from");
        let toParams = trans.params("to");

        if (toState.name === "login") {
          $rootScope.bodyClass = "marketingPage";
        } else {
          $rootScope.bodyClass = "";
        }

        if (!toState || !toState.data) return false;

        let requireLogin = toState.data.requiresLogin === true;

        if (requireLogin) {
          let user = UserProvider.getUser();
          let redirectTo;
          if ($location.search().r) {

            redirectTo = decodeURIComponent($location.search().r);
          } else if ($location.url() === "/") {
            redirectTo = "/app/dashboard";
          } else {
            redirectTo = $location.url();
          }

          if (user.isLoggedIn !== true) {
            $timeout(() => $location.url("/?r=" + encodeURI(redirectTo)));
            return false;

          } 
          else if (user.currentTermsOfUseAccepted < 1 && toState.name !== "acceptTerms") {
            // only enter this condition if we are not already trying to route to the terms of use.  Otherwise we end up in infinite loop.
            $timeout(() => $location.url("/acceptterms?r=" + encodeURIComponent(redirectTo)));
            return false;
          }
        }

        return true;
      });

      $transitions.onStart({}, function (trans) {
        //Handle slide can redirect the transition, i.e. going from main.A to main.B, causes slide-out, then slide-in animation
        return stateService.handleSlide(trans, appConstants.SLIDE_ANIM_SPEED);
      });

      $transitions.onFinish({}, function (trans) {});

      $rootScope.$on("$translateChangeSuccess", function (event, data) {
        $rootScope.language = data.language.replace(/_/g, "-");
      });

      $rootScope.$on("UserLoggedIn", function (event, user) {
        // if the user is not an alk user, remove the style from local storage in case satellite was already selected.
        if (!user.isALKUser) {
          $window.localStorage.removeItem("style");
        }
      });

      //  now the app is starting, let's see if we can log in via a cookie
      $rootScope.preloginFinished = false;
      let redirectLocation;
      let saveInfoClosure = () => {};
      if ($location.search().r) {
        redirectLocation = decodeURIComponent($location.search().r);
      } else {
        var path = $location.path();
        var urlCenter = mapUtilities.parseCenterParams($location.search());

        if (urlCenter) {
          var urlMapCenter = mapUtilities.LLtoMerc(urlCenter.center[0], urlCenter.center[1]);
          $location.search("center", null);
          saveInfoClosure = () => {
            savedMapInfo.saveCurrentInfo(urlMapCenter, urlCenter.zoom, ALKMaps.STYLE.DEFAULT);
          };
        }

        if (_.isEmpty(path) || path === "/") {
          $location.path("/app/dashboard");
          redirectLocation = $location.url();
        } else {
          let queryParams = $location.search();
          let queryString = _.map(queryParams, (v, k) => `${k}=${v}`).join("&");
          if (queryString.length > 0) {
            queryString = `?${queryString}`;
          }
          redirectLocation = path + queryString;
        }
      }

      $rootScope.preloginFinished = false;
      var skipCookieLogin = _.includes(redirectLocation, "/reset") || _.includes(redirectLocation, "/tid/redirect");
      if (!skipCookieLogin) {
        var authenticationPromise = $q.defer();
        alkAuthenticationService.verify()
          .then(() => {
            authenticationPromise.resolve();
          }, (err) => {
            authenticationPromise.reject();
          });
        authenticationPromise.promise.then(() => {
          $rootScope.preloginFinished = true;
          saveInfoClosure();
          $location.url(redirectLocation);
        }, () => {
          let finalUrl = "/";
          if (redirectLocation) {
            finalUrl += `/?r=${redirectLocation}`;
          }
          $location.url(finalUrl);
          $rootScope.preloginFinished = true;
        });
      } else {
        $rootScope.preloginFinished = true;
      }

      if (!document.getElementsByClassName) {
        document.getElementsByClassName = function (className) {
          return this.querySelectorAll("." + className);
        };
        Element.prototype.getElementsByClassName = document.getElementsByClassName;
      }

      // SWCX-556 - Everytime user goes back to the app from other browser tab, check if it still has access to this app
      VisibilityChange.configure({broadcast: true});

      $rootScope.$on("pageBecameVisible", function(event) {
        if ($rootScope.userInfo) {
          alkAuthenticationService.verifyService().then(
            (data) => {}, // user is good, do nothing
            (err) => { // user can not access any more, redirect user to login.
              UserProvider.clearUser();
              // pchen: closes an open freshchat window when kicked out
              //   after logging out in a different tab
              if (window.fcWidget) {
                window.fcWidget.destroy();
              }
              $location.url("/");
            }
          );
        }
      });
    }
  ]);
})();

// require these files so webpack includes them in the dist
require("!!file?name=[path][name].[ext]&context=./!./../web.config");
require("!!file?name=[path][name].[ext]&context=./!./../favicon.ico");

// require styles for the application
require("@trimblemaps/webtools-common/style/css/alk-icons.less");
//require("./../css/alk-bootstrap-overrides.less");
require("./../css/styles.less");
require("./../css/marketing.less");

require("./alkmapsExtension/controlCustomPlace.js");
require("./alkmapsExtension/popupAddress.js");
require("./alkmapsExtension/controlCustomPlaceDragFeature.js");
require("./alkmapsExtension/controlNetworkSnapping.js");
require("./alkmapsExtension/controlYardSnapping.js");
require("./alkmapsExtension/controlYardGateDragFeature.js");
require("./alkmapsExtension/controlDrawFeatureOpt.js");

require("./app.translate.js");

require("@trimblemaps/webtools-common/javascript/AngularJS/Common/common-services");
require("@trimblemaps/webtools-common/javascript/AngularJS/Common/geoParser");
require("@trimblemaps/webtools-common/javascript/AngularJS/Common/common-directives");
require("@trimblemaps/webtools-common/javascript/AngularJS/Common/common-filters");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-translations/module");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-translations/alkLocaleService");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-translations/alkTranslationLoader");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-translations/alklanguageSelectDirective");

require("@trimblemaps/webtools-common/javascript/AngularJS/alk-authentication/module");

require("@trimblemaps/webtools-common/javascript/AngularJS/Maps/mapsTextPath");
require("@trimblemaps/webtools-common/javascript/AngularJS/Maps/mapsLocation");

require("@trimblemaps/webtools-common/javascript/AngularJS/alk-geocode/module");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-maps/module");

require("@trimblemaps/webtools-common/javascript/AngularJS/alk-maps/map.service");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-maps/map.utilities");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-maps/map.savedInfo");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-maps/mapStyleMenu.directive");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-maps/mapFooter.directive");

require("@trimblemaps/webtools-common/javascript/AngularJS/alk-constants/module.js");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-constants/states.js");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-constants/regions.js");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-constants/countries.js");

require("@trimblemaps/webtools-common/javascript/AngularJS/alk-forms/module");

require("@trimblemaps/webtools-common/javascript/AngularJS/alk-analytics/alkAnalytics");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-cloud/alkCloudMenu.directive");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-modal/module");

require("@trimblemaps/webtools-common/javascript/AngularJS/alk-uirouter/module");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-uirouter/stateService");

require("@trimblemaps/webtools-common/javascript/AngularJS/alk-validation/tid-password");

require("./compliance/complianceMap.service");
require("./compliance/compliance.service");
require("./compliance/complianceGroup.controller");
require("./compliance/compliance-querystring.component");
require("./compliance/groups.service");
require("./compliance/complianceRoutingProfile.service");
require("./compliance/complianceGroups.controller");
require("./compliance/compliance-routes.component");
require("./compliance/compliance-routedetail.component");
require("./compliance/routingprofile-select.directive");

require("./reports/reports.controller");

require("./dashboard/dashboard.controller");

require("./components/other.directives.js");
require("./components/list.directive.js");
require("./components/datetimepick.directive.js");
require("./components/datetimepick.directive");
require("./components/cache.service");
require("./components/time.service");

require("./map/map.controller");
require("./layout/layoutService");
require("./layout/nav.directive");

require("./auth/forgotPassword.controller");
require("./auth/resetPassword.controller");
require("./auth/terms.controller");
require("./auth/login.controller");
require("./auth/user.controller");
require("./auth/tidLogin.controller");
require("./auth/tidLogin.service");

require("./components/alkLocationItem");

console.log(process.env.ALK_APP + " running...");

require("@trimblemaps/webtools-common/javascript/AngularJS/alk-maps/alkmaps.directive");
require("./map/mapNavigation.directive");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-marketing/module");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-marketing/landing.controller");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-marketing/footer.directive");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-marketing/hubspotForm.directive");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-sso/module");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-email/module");
require("@trimblemaps/webtools-common/javascript/AngularJS/alk-company-admin/module");
require("@trimblemaps/webtools-common/javascript/AngularJS/tm-nav-buttons-three-stack/module");

// include necessary languages
require("!!file?name=[path][name].[ext]&context=.!../node_modules/angular-i18n/angular-locale_en.js");
require("!!file?name=[path][name].[ext]&context=.!../node_modules/angular-i18n/angular-locale_en-us.js");
require("!!file?name=[path][name].[ext]&context=.!../node_modules/angular-i18n/angular-locale_de.js");
require("!!file?name=[path][name].[ext]&context=.!../node_modules/angular-i18n/angular-locale_de-de.js");
require("!!file?name=[path][name].[ext]&context=.!../node_modules/angular-i18n/angular-locale_es.js");
require("!!file?name=[path][name].[ext]&context=.!../node_modules/angular-i18n/angular-locale_es-es.js");



// WEBPACK FOOTER //
// ./app/app.js